import { useSyncExternalStore } from 'react';

import { expVal } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';

const TRACKED_NETWORK_EVENTS: (keyof WindowEventMap)[] = ['load', 'online', 'offline'];

const isOnlineSubscribe: Parameters<typeof useSyncExternalStore<boolean>>[0] = (callback) => {
	TRACKED_NETWORK_EVENTS.forEach((event) => window.addEventListener(event, callback));
	return () => {
		TRACKED_NETWORK_EVENTS.forEach((event) => window.removeEventListener(event, callback));
	};
};

const isOnlineGetSnapshot: Parameters<typeof useSyncExternalStore<boolean>>[1] = () =>
	navigator.onLine;

// During SSR rendering, we can't check the navigator status, so instead we'll assume the user is online
const isOnlineGetServerSnapshot: Parameters<typeof useSyncExternalStore<boolean>>[2] = () => true;

export const useEditorNetworkStatus = () => {
	const isOnline = useSyncExternalStore(
		isOnlineSubscribe,
		isOnlineGetSnapshot,
		isOnlineGetServerSnapshot,
	);

	// TODO ED-28516: This is currently broken and incorrectly showing the user as offline when they are online. Defaulting to always online when override is enabled.
	return {
		isNetworkDisabled: expVal('platform_editor_offline_editing_web', 'isEnabled', false)
			? !isOnline && !fg('platform_editor_offline_editing_wrapper_override')
			: false,
	};
};
